import React from 'react';
import { useMouseEnterLeaveEvents } from './useMouseEnterLeaveEvents';

export const useHoverState = ({
  forwardRef,
} = {}) => {
  const [isHovered, setIsHovered] = React.useState(false);
  const setHoverOn = React.useCallback(() => setIsHovered(true), []);
  const setHoverOff = React.useCallback(() => setIsHovered(false), []);

  const [ref] = useMouseEnterLeaveEvents({
    forwardRef,
    onMouseEnter: setHoverOn,
    onMouseLeave: setHoverOff,
  });

  return [ref, isHovered];
};
